import { Component } from '@angular/core';

@Component({
  selector: 'app-contract-template',
  templateUrl: './contract-template.component.html',
  styleUrl: './contract-template.component.scss'
})
export class ContractTemplateComponent {
  bodySpinner:boolean=false;
}
